<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="6" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="dataExpensesTotalOverhead" 
                            label="Total Overhead"
                            prepend-inner-icon="mdi-currency-usd"
                            disabled
                            persistent-hint
                            hint="Calculation of all expenses below">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesEmployeeCompensationLicensed" 
                            label="Employee Compensation (Licensed)"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesEmployeeCompensationAdmin" 
                            label="Employee Compensation (Admin)"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesContractorCompensation" 
                            label="Contractor Compensation"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesEmployeeBenefits" 
                            label="Employee Benefits"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataEexpensesEmployeeOnlyPayrollTaxes" 
                            label="Employee Only Payroll Taxes"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesInsurance" 
                            label="Insurance"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesProfessionalServices" 
                            label="Professional Services"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesContinuingEducation" 
                            label="Continuing Education"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesLicensingCost"
                            label="Licensing Cost"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesAnnualLeaseRent"
                            label="Annual Lease/Rent"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesOther"
                            label="Other"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="6" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.expenses_percent_of_revenue"
                            label="Expenses as a Percentage of Revenue"
                            append-icon="mdi-percent"
                            disabled
                            persistent-hint
                            hint="Calculation of Trailing 12 Month Revenue and Total Overhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesAdvertising"
                            label="Advertising"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesEntertainment"
                            label="Entertainment"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesTravel"
                            label="Travel"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesReferralFees"
                            label="Referral Fees"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesDues"
                            label="Dues"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesSoftwareCosts"
                            label="Software Costs"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesOfficeSupplies"
                            label="Office Supplies"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesUtilities"
                            label="Utilities"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesMaintenance"
                            label="Maintenance"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataExpensesBrokerDealerFees"
                            label="Broker Dealer Expenses"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateExpensesTotalOverhead">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="editData.expenses_notes"
                            label="Notes"
                            auto-grow
                            rows="5" >
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    import { 
        formatNumbers,
        scrubNumbers } from '../../helpers/utilities'

    export default {
        name: 'ExpenseBreakdown',
        props: [
            'editData',
            'calcExpensesPercentageRevenue'
        ],

        data: () => ({}),
        
        watch: {
            dataExpensesTotalOverhead (val) {
                this.$emit('calcExpensesPercentageRevenue', { 'expenses_total_overhead': this.editData.expenses_total_overhead, 'revenue_t12_months': this.editData.revenue_t12_months } )
            }
        },
        
        computed: {
            dataExpensesTotalOverhead: {
                get: function() {
                    return this.editData.expenses_total_overhead != null ? formatNumbers(this.editData.expenses_total_overhead) : ''
                },
                set: function(val) {
                    this.calculateExpensesTotalOverhead;
                }
            },

            dataExpensesEmployeeCompensationLicensed: {
                get: function() {
                    return this.editData.expenses_employee_compensation_licensed != null ? formatNumbers(scrubNumbers(this.editData.expenses_employee_compensation_licensed)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_employee_compensation_licensed', val);
                    return val;
                }
            },
            dataExpensesEmployeeCompensationAdmin: {
                get: function() {
                    return this.editData.expenses_employee_compensation_admin != null ? formatNumbers(scrubNumbers(this.editData.expenses_employee_compensation_admin)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('expenses_employee_compensation_admin', val);
                    return val
                }
            },
            dataExpensesContractorCompensation: {
                get: function() {
                    return this.editData.expenses_contractor_compensation != null ? formatNumbers(scrubNumbers(this.editData.expenses_contractor_compensation)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_contractor_compensation', val);
                    return val;
                }
            },
            dataExpensesEmployeeBenefits: {
                get: function() {
                    return this.editData.expenses_employee_benefits != null ? formatNumbers(scrubNumbers(this.editData.expenses_employee_benefits)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_employee_benefits', val);
                    return val;
                }
            },
            dataEexpensesEmployeeOnlyPayrollTaxes: {
                get: function() {
                    return this.editData.expenses_employee_only_payroll_taxes != null ? formatNumbers(scrubNumbers(this.editData.expenses_employee_only_payroll_taxes)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_employee_only_payroll_taxes', val);
                    return val;
                }
            },
            dataExpensesInsurance: {
                get: function() {
                    return this.editData.expenses_insurance != null ? formatNumbers(scrubNumbers(this.editData.expenses_insurance)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('expenses_insurance', val);
                    return val
                }
            },
            dataExpensesProfessionalServices: {
                get: function() {
                    return this.editData.expenses_professional_services != null ? formatNumbers(scrubNumbers(this.editData.expenses_professional_services)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_professional_services', val);
                    return val;
                }
            },
            dataExpensesBrokerDealerFees: {
                get: function() {
                    return this.editData.expenses_broker_dealer_fees != null ? formatNumbers(scrubNumbers(this.editData.expenses_broker_dealer_fees)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_broker_dealer_fees', val);
                    return val;
                }
            },
            dataExpensesContinuingEducation: {
                get: function() {
                    return this.editData.expenses_continuing_education != null ? formatNumbers(scrubNumbers(this.editData.expenses_continuing_education)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_continuing_education', val);
                    return val;
                }
            },
            dataExpensesLicensingCost: {
                get: function() {
                    return this.editData.expenses_licensing_cost != null ? formatNumbers(scrubNumbers(this.editData.expenses_licensing_cost)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('expenses_licensing_cost', val);
                    return val
                }
            },
            dataExpensesAnnualLeaseRent: {
                get: function() {
                    return this.editData.expenses_annual_lease_rent != null ? formatNumbers(scrubNumbers(this.editData.expenses_annual_lease_rent)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_annual_lease_rent', val);
                    return val;
                }
            },
            dataExpensesAdvertising: {
                get: function() {
                    return this.editData.expenses_advertising != null ? formatNumbers(scrubNumbers(this.editData.expenses_advertising)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_advertising', val);
                    return val;
                }
            },
            dataExpensesEntertainment: {
                get: function() {
                    return this.editData.expenses_entertainment != null ? formatNumbers(scrubNumbers(this.editData.expenses_entertainment)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('expenses_entertainment', val);
                    return val
                }
            },
            dataExpensesTravel: {
                get: function() {
                    return this.editData.expenses_travel != null ? formatNumbers(scrubNumbers(this.editData.expenses_travel)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_travel', val);
                    return val;
                }
            },
            dataExpensesReferralFees: {
                get: function() {
                    return this.editData.expenses_referral_fees != null ? formatNumbers(scrubNumbers(this.editData.expenses_referral_fees)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_referral_fees', val);
                    return val;
                }
            },
            dataExpensesDues: {
                get: function() {
                    return this.editData.expenses_dues != null ? formatNumbers(scrubNumbers(this.editData.expenses_dues)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_dues', val);
                    return val;
                }
            },
            dataExpensesSoftwareCosts: {
                get: function() {
                    return this.editData.expenses_software_costs != null ? formatNumbers(scrubNumbers(this.editData.expenses_software_costs)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('expenses_software_costs', val);
                    return val
                }
            },
            dataExpensesOfficeSupplies: {
                get: function() {
                    return this.editData.expenses_office_supplies != null ? formatNumbers(scrubNumbers(this.editData.expenses_office_supplies)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_office_supplies', val);
                    return val;
                }
            },
            dataExpensesUtilities: {
                get: function() {
                    return this.editData.expenses_utilities != null ? formatNumbers(scrubNumbers(this.editData.expenses_utilities)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_utilities', val);
                    return val;
                }
            },
            dataExpensesMaintenance: {
                get: function() {
                    return this.editData.expenses_maintenance != null ? formatNumbers(scrubNumbers(this.editData.expenses_maintenance)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('expenses_maintenance', val);
                    return val
                }
            },
            dataExpensesOther: {
                get: function() {
                    return this.editData.expenses_other != null ? formatNumbers(scrubNumbers(this.editData.expenses_other)) : ''
                },
                set: function(val) {
                    this.swapNumbers('expenses_other', val);
                    return val;
                }
            }
        },

        mounted () {},

        methods: {
            swapNumbers: function (field, val) {
                this.editData[field] = scrubNumbers(val);
            },

            calculateExpensesTotalOverhead: function () {
                const calculated_val = Math.round( 
                    (parseInt(this.editData.expenses_employee_compensation_licensed) || 0) + 
                    (parseInt(this.editData.expenses_employee_compensation_admin) || 0) +
                    (parseInt(this.editData.expenses_contractor_compensation) || 0) +
                    (parseInt(this.editData.expenses_employee_benefits) || 0) +
                    (parseInt(this.editData.expenses_employee_only_payroll_taxes) || 0) +
                    (parseInt(this.editData.expenses_insurance) || 0) +
                    (parseInt(this.editData.expenses_professional_services) || 0) +
                    (parseInt(this.editData.expenses_continuing_education) || 0) +
                    (parseInt(this.editData.expenses_licensing_cost) || 0) +
                    (parseInt(this.editData.expenses_annual_lease_rent) || 0) +
                    (parseInt(this.editData.expenses_advertising) || 0) +
                    (parseInt(this.editData.expenses_entertainment) || 0) +
                    (parseInt(this.editData.expenses_travel) || 0) +
                    (parseInt(this.editData.expenses_referral_fees) || 0) +
                    (parseInt(this.editData.expenses_dues) || 0) +
                    (parseInt(this.editData.expenses_software_costs) || 0) +
                    (parseInt(this.editData.expenses_office_supplies) || 0) +
                    (parseInt(this.editData.expenses_utilities) || 0) +
                    (parseInt(this.editData.expenses_maintenance) || 0) +
                    (parseInt(this.editData.expenses_broker_dealer_fees) || 0) +
                    (parseInt(this.editData.expenses_other) || 0)
                );

                this.dataExpensesTotalOverhead = formatNumbers(calculated_val);
                //console.log(this.dataExpensesTotalOverhead)
                this.editData.expenses_total_overhead = parseInt(calculated_val);
                //console.log(this.editData.expenses_total_overhead)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/ExpenseBreakdown.vue